import React from 'react';

import * as ModalContainer from 'ui-library/ModalContainer';

import CreateComponentModal from './CreateComponentModal';

interface Props {
  initialFolderId: string;
  namePlaceholder?: string;
  onRequestClose: () => void;
  onConfirm: ({folderId, name}: {folderId: string; name: string}) => void;
  displaySelectionStart: number;
  displaySelectionEnd: number;
}

function CreatePartModal(props: Props): JSX.Element {
  const description =
    'A new part will be created and this region ' +
    `(${props.displaySelectionStart}-${props.displaySelectionEnd}) ` +
    'will be replaced with it.';
  return (
    <CreateComponentModal
      confirmButtonText="Replace"
      description={description}
      initialFolderId={props.initialFolderId}
      readableItemType="part"
      namePlaceholder={props.namePlaceholder}
      onConfirm={props.onConfirm}
      onRequestClose={props.onRequestClose}
      title="Replace selection with part"
    />
  );
}

CreatePartModal.open = (props: Props): void => {
  const modalProps = {
    ...props,
    onRequestClose: () => {
      ModalContainer.close(CreatePartModal);
    },
  };
  ModalContainer.open(CreatePartModal, <CreatePartModal {...modalProps} />);
};

export default CreatePartModal;
